import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71992a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = {
  id: "content",
  ref: "content"
}
const _hoisted_3 = {
  ref: "help",
  href: "https://github.com/Sank6/YouTube-Wrapped/wiki",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FileInputButton = _resolveComponent("FileInputButton")!
  const _component_FillingUp = _resolveComponent("FillingUp")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_ErrorComponent = _resolveComponent("ErrorComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TextInput, {
        id: "apikey",
        ref: "key",
        prompt: "Google API Key",
        onInput: _ctx.loadkey
      }, null, 8, ["onInput"]),
      _createVNode(_component_FileInputButton, {
        ref: "button",
        apikey: _ctx.apikey,
        onEmpty: _ctx.flashkey,
        onLoad: _ctx.getInfo
      }, null, 8, ["apikey", "onEmpty", "onLoad"]),
      _createElementVNode("a", _hoisted_3, "help?", 512),
      _createVNode(_component_FillingUp, {
        ref: "water",
        colour: _ctx.colour
      }, null, 8, ["colour"]),
      _createVNode(_component_Stats, _mergeProps({
        ref: "stats",
        id: "stats"
      }, _ctx.stats), null, 16),
      _createVNode(_component_ErrorComponent, _mergeProps({ ref: "error" }, _ctx.error), null, 16)
    ], 512)
  ]))
}